import { Fragment } from 'react';
import './ModalDialog.css';

const ModalDialog = ({ children, position = 'default', onClose, className = '', backgroundClassName = '' }) => {
	return (
		<Fragment>
			<div className={`modal-background ${backgroundClassName}`} />
			<div className={`modal-dialog-container ${position === 'default' ? '' : position} ${className}`}>
				<div className="modal-dialog shadow-large">{children}</div>
			</div>
		</Fragment>
	);
};

export default ModalDialog;
